import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { AddQuiz, UploadCreationTool, UploadCreationToolButton } from "@kaltura/mediaspace-features-add-quiz";

export { UploadCreationTool, UploadCreationToolButton };

export const render = getDsLayoutComponentRenderer(AddQuiz);
